const FormResources = {

    form_data:  {
        area_id:             '',
        room_type_id:        '',
        cost_center_id:      '',
        door_number:         '',
        description:         '',
        description_2:       '',
        walking_number:      '',
        sq_ft:               '',
        patient:             false,
        // time_adjustment:     '',
        work_group:          false,
        exclude_daily:       false,
        exclude_project:     false,
        closed:                false,
        essential_cleaning:  false,
        notes:               '',
        fixtures:            [],
        floor_id:            '',
        daily_task_id:       '',
        fixture_number:      ''
        // room_id:            '',
        // child:              false,
    },

    task_form_data:  {
        room_id:            '',
        task_id:            '',
        frequency_id:       '',
        frequency_manual:   '',
        previous_frequency_manual:   '',
        minutes_discount:   '',
        minutes:            '',
        shift1:             false,
        shift2:             false,
        shift3:             false,
    },

    complete_project_form_data:  {
        room_task_id:       '',
        completed_date:     '',
        minutes:            '',
        associate_id:       '',
        comment:            '',
    },

    form_format:[
        {
            css_class:  'col-md-4',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building Level Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Door number:',
            model_name: 'door_number',
            ref:        'door_number_input',
            ref_alt:    'door_number_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Walking #:',
            model_name: 'walking_number',
            ref:        'walking_number_input',
            ref_alt:    'walking_number_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Room type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Sq. Feet:',
            model_name: 'sq_ft',
            ref:        'sq_ft_input',
            ref_alt:    'sq_ft_input_alt',
            required:   true,
        },
        // {
        //     css_class:  'col-md-4',
        //     type:       'select',
        //     maxlength:  '',
        //     disabled:   false,
        //     step:       '',
        //     name:       'Floor type:',
        //     model_name: 'floor_id',
        //     ref:        'floor_input',
        //     ref_alt:    'floor_input_alt',
        //     required:   false,
        // },
        {
            css_class:  'col-md-4',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Cost center:',
            model_name: 'cost_center_id',
            ref:        'cost_center_id_input',
            ref_alt:    'cost_center_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Description 2:',
            model_name: 'description_2',
            ref:        'description_2_input',
            ref_alt:    'description_2_input_alt',
            required:   false,
        },
        // {
        //     css_class:  'col-md-4',
        //     type:       'number',
        //     maxlength:  '',
        //     disabled:   false,
        //     step:       'any',
        //     name:       'Time adjustment:',
        //     model_name: 'time_adjustment',
        //     ref:        'time_adjustment_input',
        //     ref_alt:    'time_adjustment_input_alt',
        //     required:   false,
        // },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Closed:',
            model_name: 'closed',
            ref:        'closed_input',
            ref_alt:    'closed_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Essential cleaning:',
            model_name: 'essential_cleaning',
            ref:        'essential_cleaning_input',
            ref_alt:    'essential_cleaning_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Patient:',
            model_name: 'patient',
            ref:        'patient_input',
            ref_alt:    'patient_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Work group 2:',
            model_name: 'work_group',
            ref:        'work_group_input',
            ref_alt:    'work_group_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Exclude dailys:',
            model_name: 'exclude_daily',
            ref:        'exclude_daily_input',
            ref_alt:    'exclude_daily_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-8',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Exclude projects:',
            model_name: 'exclude_project',
            ref:        'exclude_project_input',
            ref_alt:    'exclude_project_input_alt',
            required:   false,
        },
        // {
        //     css_class:  'col-md-12',
        //     type:       'textarea',
        //     maxlength:  245,
        //     disabled:   false,
        //     step:       '',
        //     name:       'Notes:',
        //     model_name: 'notes',
        //     ref:        'notes_input',
        //     ref_alt:    'notes_input_alt',
        //     required:   false,
        // },
    ],

    form_format2:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Floor type:',
            model_name: 'floor_id',
            ref:        'floor_input',
            ref_alt:    'floor_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Notes:',
            model_name: 'notes',
            ref:        'notes_input',
            ref_alt:    'notes_input_alt',
            required:   false,
        },
    ],

    form_format_complete_project:[
        {
            css_class:  'col-md-3',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Completed date:',
            model_name: 'completed_date',
            ref:        'completed_date_input',
            ref_alt:    'completed_date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-3',
            type:       'text',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Minutes to complete:',
            model_name: 'minutes',
            ref:        'minutes_input',
            ref_alt:    'minutes_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            label:      'associate_name',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'text',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Comment:',
            model_name: 'comment',
            ref:        'comment_input',
            ref_alt:    'comment_input_alt',
            required:   false,
        },
    ],

}

export default FormResources